import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toastNotify } from "../../components/Helper";
import { fetchData, USER_LIST } from "../../components/Service";
import Barcode from "react-barcode";
import { useContext } from "react";
import { Context } from "../../components/Context";
import { useEffect } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const Dashboard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  window.document.title = `${t("Dashboard")} | ${t("Panda")}`;
  const [context] = useContext(Context);
  const [reload, setReload] = useState(false);

  async function verifyEmail() {
    try {
      if (context && context.id) {
        setReload(true);
        fetchData(
          `${USER_LIST}/${context.id}/email_verification`,
          "GET",
          "",
          true,
          true,
          (res) => {
            if (res.status) {
              toastNotify("success", t("Email Verification link send"));
            } else {
              res.error &&
                res.error.message &&
                toastNotify(
                  "danger",
                  res.message ? res.message : t("Something went wrong")
                );
            }
            setReload(false);
          }
        );
      }
    } catch (err) {
      toastNotify("danger", t("Invalid action perform"));
    }
  }

  useEffect(() => {
    if (
      (context && context.request_profile_confirmation) ||
      !context.firstname ||
      !context.lastname ||
      !context.gender ||
      !context.birthdate ||
      !context.email ||
      !context.mobile ||
      !context.is_terms_accepted ||
      !context.is_loyalty_customer
    ) {
      navigate("/admin/registration");
    }
  }, [context, navigate]);

  async function navigate_profile() {
    navigate("/admin/registration");
  }

  const downloadSVG = () => {
    var input = document.getElementById("bar_code_section");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 35, 75, 0, 0);
      pdf.save("Barcode.pdf");
    });
  };

  return (
    <>
      {context && (
        <section className="dashboard">
          <div className="container">
            <div className="col-sm-12 pb-3">
              <h4 className="pt-5 px-4 text-green">
                {t("Hi")}, {context && context.firstname}
              </h4>
              <h5 className="px-4 text-green">{t("Welcome to Panda Plus")}</h5>
            </div>

            <div className="row d-flex justify-content-center px-4">
              {!(context && context.email_verified) && (
                <div className="col-sm-12 mb-3">
                  <button
                    type="button"
                    onClick={() => verifyEmail()}
                    className="btn btn-primary text-white"
                    disabled={reload}
                  >
                    <i className="bi bi-info-circle-fill"></i>{" "}
                    {t("Email Not Verified")}{" "}
                    {reload && (
                      <span className="spinner-border spinner-border-sm mr-1"></span>
                    )}
                  </button>
                </div>
              )}
              {(context.request_profile_confirmation ||
                !context.firstname ||
                !context.lastname ||
                !context.gender ||
                !context.birthdate ||
                !context.email ||
                !context.mobile ||
                !context.is_terms_accepted) && (
                <div className="col-sm-12 mb-4">
                  <button
                    type="button"
                    onClick={() => navigate_profile()}
                    className="btn btn-danger"
                    disabled={reload}
                  >
                    <i className="bi bi-info-circle-fill"></i>{" "}
                    {t("Prfile Reminder")}{" "}
                    {reload && (
                      <span className="spinner-border spinner-border-sm mr-1"></span>
                    )}
                  </button>
                </div>
              )}

              <div className="col-md-6 col-sm-12 mb-3 order-2">
                <div className="dashboard-para my-auto text-center">
                  <div className="dashboard-image" id="bar_code_section">
                    {context && context.crm_loyalty_number && (
                      <Barcode
                        value={context.crm_loyalty_number}
                        fontOptions="bold"
                        background="#e8f3db"
                        lineColor="#004a2c"
                        width={4}
                        height={120}
                      />
                    )}
                  </div>

                  <div className="flex-float mt-2">
                    <button
                      className="btn btn-sm border border-success"
                      onClick={() => downloadSVG()}
                    >
                      <i className="bi bi-download mx-2"></i>
                      {t("Download")}
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-sm-12 mb-3 order-2">
                <img
                  src={t("Images.loyalty_card")}
                  alt=""
                  width="100%"
                  height="100%"
                  style={{ textAlign: "center", borderRadius: "35px" }}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Dashboard;
